export default __webpack_public_path__ + "locales/pt/FilesSettings.json?hash=0836b913e05351703ec587d23b5d3f12";